// extracted by mini-css-extract-plugin
export default {"conflictContainer":"YCKaY","shakeWrapper":"DEMf4","title":"XJkNE","conflictButton":"nrTQc","container":"OYLIx","noMoneyComponent":"xzcwi"};